import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { isVideoEmbed as isVideoEmbedSelector } from 'services/user-layout';
import { StyledVideo } from './styles';
import Image from 'components/objects/Image';
import { getChannelOfflineMode } from 'services/admin/selectors';
import { IVideo } from 'models';
import { PlayerSpot } from 'services/video';

const ChannelOfflineContent: FC<{
  loop: boolean;
  onVideoEnd?: () => void;
  video?: IVideo;
}> = ({ video, onVideoEnd, loop }) => {
  const offlineMode = useSelector(getChannelOfflineMode);
  const isVideoEmbed = useSelector(isVideoEmbedSelector);

  if (video) {
    return (
      <StyledVideo
        video={video}
        isVideoEmbed={isVideoEmbed}
        scheduledVideoStartTime={null}
        spot={PlayerSpot.tv}
        onVideoComplete={onVideoEnd}
        loop={loop}
      />
    );
  }

  return (
    <Image
      // show default image while video is loading
      showPlaceholder={offlineMode === 'tv'}
    />
  );
};

export default ChannelOfflineContent;
